<template>
  <div>
    <div v-if="$store.state.modules.account.user" class="nav-item">
        <mainSignOutButton class="dropdown-item" />
    </div>
    <div v-else class="navbar align-self-center d-flex">
      <div class="nav-item">
        <router-link :to="{ name: 'Signin' }" custom v-slot="{ navigate }">
          <a
            role="link"
            @click="navigate"
            class="me-2 btn btn-outline-primary btn-sm"
            @keypress.enter="navigate"
            title="Signin"
          >
            <i class="fa-solid fa-sm fa-arrow-right-to-bracket me-1"></i>
            Log in
          </a>
        </router-link>
      </div>

      <div class="nav-item">
        <router-link :to="{ name: 'Signup' }" custom v-slot="{ navigate }">
          <span
            role="link"
            @click="navigate"
            class="btn btn-primary btn-sm"
            title="Sign up"
            @keypress.enter="navigate"
          >
            <i class="fa-solid fa-user-plus fa-sm me-1"></i>
            Sign up
          </span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import mainSignOutButton from "../../authentication/components/SignOut.vue";

export default {
  name: "Dropdown",

  components: {
    mainSignOutButton,
  },

  data() {
    return {};
  },

  mounted() {
    this.$nextTick(() => {});
  },

  watch: {},

  methods: {},
};
</script>
